import styled, { css } from "styled-components";

import { Link } from "react-router-dom";
import { Text } from "../typography";
import { colors } from "../../assets/styles/parameters";

export const Button = ({
  version,
  varient,
  size,
  path,
  text,
  type,
  state,
  ...otherProps
}) => {
  switch (version) {
    case "link":
      return (
        <StyledButton size={size} ty={varient} type={type} {...otherProps}>
          <Link to={path} {...otherProps} state={state}>
            {text}
          </Link>
        </StyledButton>
      );
    default:
      return (
        <StyledButton size={size} ty={varient} type={type} {...otherProps}>
          <Text>{text}</Text>
        </StyledButton>
      );
  }
};

export const ToggleButton = ({ onTurnOnOFF, value }) => {
  return (
    <StyledWrapper>
      <div className="fx-block">
        <div className="toggle">
          <div>
            <input
              type="checkbox"
              id="toggles"
              defaultChecked={value}
              onClick={(e) => onTurnOnOFF(e)}
            />
            <div data-unchecked="On" data-checked="Off"></div>
          </div>
        </div>
      </div>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  .toggle > div {
    position: relative;
    padding: 10px;
    width: 120px;
    height: 50px;
    border-radius: 50px;
    box-shadow: 0 -1px 1px 0 rgba(0, 0, 0, 0.5),
      0px 1px 1px 0 rgba(255, 255, 255, 1);
    background: rgb(189, 191, 193);
    background: linear-gradient(
      to bottom,
      rgba(189, 191, 193, 1) 0%,
      rgba(249, 251, 254, 1) 100%
    );
  }

  .toggle > div > input[type="checkbox"] {
    position: absolute;
    opacity: 0;
    top: -0px;
    left: 10px;
    width: 130px;
    height: 30px;
    z-index: 5;
  }

  .toggle > div > input[type="checkbox"] ~ div {
    width: 100px;
    height: 30px;
    border-radius: 50px;
    border: 1px solid #979797;
    box-shadow: inset 5px 0 0 0 rgba(0, 0, 0, 0.1),
      inset -5px 0 0 0 rgba(0, 0, 0, 0.1),
      inset -6px 0 0 0 rgba(255, 255, 255, 0.5),
      inset -4px 6px 11px -5px rgba(0, 0, 0, 0.2),
      inset 1px 1px 0 0 rgba(255, 255, 255, 1),
      -6px 4px 11px -7px rgba(0, 0, 0, 0.5);
    background: rgb(253, 252, 251);
    background: linear-gradient(
      to right,
      rgba(253, 252, 251, 1) 37%,
      rgba(229, 229, 229, 1) 61%
    );
  }

  .toggle > div > input[type="checkbox"]:checked ~ div {
    box-shadow: inset -5px 0 0 0 rgba(0, 0, 0, 0.1),
      inset 5px 0 0 0 rgba(0, 0, 0, 0.1),
      inset 6px 0 0 0 rgba(255, 255, 255, 0.5),
      inset -4px 6px 11px -5px rgba(0, 0, 0, 0.2),
      inset 1px 1px 0 0 rgba(255, 255, 255, 1),
      -6px 4px 11px -7px rgba(0, 0, 0, 0.5);
    /* background: rgb(229, 229, 229); */
    background: linear-gradient(
      to right,
      rgba(229, 229, 229, 1) 39%,
      rgba(253, 252, 251, 1) 63%
    );
  }

  .toggle > div > input[type="checkbox"] ~ div:before {
    content: attr(data-unchecked);
    display: block;
    position: absolute;
    border-radius: 10px;
    top: 10px;
    left: 30px;
  }

  .toggle > div > input[type="checkbox"] ~ div:after {
    content: attr(data-checked);
    color: #df0000;
    text-shadow: 0 1px 0 #fff, 0px 0 7px #df0000;
    filter: dropshadow(color=#df0000, offx=0, offy=0);
    display: block;
    position: absolute;
    border-radius: 10px;
    top: 10px;
    left: 70px;
  }

  .toggle > div > input[type="checkbox"]:checked ~ div:before {
    color: #119400;
    text-shadow: 0 1px 0 #fff, 0px 0 7px #007a08;
    filter: dropshadow(color=#007a08, offx=0, offy=0);
  }

  .toggle > div > input[type="checkbox"]:checked ~ div:after {
    color: #000;
    text-shadow: none;
    filter: dropshadow(none);
  }
`;

const BaseButton = styled.button`
  &,
  &:link,
  &:visited {
    display: inline-block;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    user-select: none;
    width: max-content;
    margin-bottom: 1rem;
    cursor: pointer;
  }

  &:focus {
    outline: 0;
  }

  &:disabled {
    opacity: 0.65;
    cursor: auto;
  }

  &:not(:disabled) {
    cursor: pointer;
  }
`;

const Varients = ({ ty }) => {
  switch (ty) {
    case "outlineWH":
      return css`
        background: transparent;
        border: 1px solid ${colors.white};
        color: ${colors.white};

        a,
        p {
          color: ${colors.white};
        }
      `;
    case "outlineBK":
      return css`
        background: transparent;
        border: 1px solid ${colors.black};
        color: ${colors.black};

        a,
        p {
          color: ${colors.black};
        }
      `;
    case "outlineGold":
      return css`
        background: transparent;
        border: 1px solid ${colors.gold};
        color: ${colors.gold};

        a,
        p {
          color: ${colors.gold};
        }
      `;
    case "gold":
      return css`
        background: ${colors.gold};
        border: 1px solid ${colors.gold};
        color: ${colors.white};

        a,
        p {
          color: ${colors.white};
        }
      `;
    default:
      return css`
        background: ${colors.black};
        border: 1px solid ${colors.black};
        color: ${colors.white};

        a,
        p {
          color: ${colors.white};
        }
      `;
  }
};

const Sizes = ({ size }) => {
  switch (size) {
    default:
      return css`
        a,
        p {
          display: inline-block;
          padding: 0.6rem 2rem;
          margin: 0;
        }
      `;
  }
};

const Shape = ({ shape }) => {
  switch (shape) {
    case "circle":
      return css`
        border-radius: 50%;
        padding: 0.75rem 1rem;
      `;
    default:
      return css`
        border-radius: 50px;
      `;
  }
};

const StyledButton = styled(BaseButton)`
  ${Sizes}
  ${Varients}
  ${Shape}
`;
